//from settings
const defaultCoverImgSettings = '/img/bacimg1.png'; //for background in header
const loginCoverImgSettings = '/img/bacimg2.png'; //for login page

//user
const defaultUserLogo = '/img/default-avatar.jpg';

//login
const defaultLogin = '/img/loginbg.jpg';

//header
const defaultLogoSite = '/img/logo.png'; //for logo in header
const defaultColorBack = 'yarea-violet';

export default {
  defaultLogin,
  defaultLogoSite,
  defaultUserLogo,
  defaultColorBack,
  loginCoverImgSettings,
  defaultCoverImgSettings,
};



// WEBPACK FOOTER //
// ./src/helpers/defaultImages.helper.js